import { useState } from "react";

const useUpdating = () => {
  const [updating, setUpdating] = useState<boolean>(false);

  return {
    updating,
    changeUpdating: (loadingState: boolean) => setUpdating(loadingState),
  };
};

export default useUpdating;
